import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import HomePage from "./pages/HomePage";
import Employee from "./pages/Employee";
import ComingSoon from "./pages/ComingSoon";
import Islemler from "./pages/Islemler";
import Tally from "./pages/Tally";
import EmployeeDetail from "./pages/EmployeeDetail";
import Institution from "./pages/Institution";
import Settings from "./pages/Settings";
import Dosyalar from "./pages/Dosyalar"; // 🔥 ekle
import Giris from "./pages/Login"; // 🔥 ekle
import PrivateRoute from "./pages/PrivateRoute";

function App() {
  return (
    <Routes>

      {/* 🔓 Login sayfası */}
      <Route path="/login" element={<Giris />} />

      {/* 🔐 Korumalı alan */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/anasayfa" replace />} />
        <Route path="anasayfa" element={<HomePage />} />
        <Route path="personel" element={<Employee />} />
        <Route path="personel/:id" element={<EmployeeDetail />} />
        <Route path="is-yonetimi" element={<ComingSoon pagesName="İş Yönetimi" />} />
        <Route path="puantaj" element={<Tally />} />
        <Route path="ozluk-dosyalari" element={<ComingSoon pagesName="Özlük Dosyaları" />} />
        <Route path="islemler" element={<Islemler pagesName="İşlemler" />} />
        <Route path="eklemeler" element={<Institution pagesName="Eklemeler" />} />
        <Route path="dosyalar" element={<Dosyalar pagesName="Dosyalar" />} />
        <Route path="ayarlar" element={<Settings pagesName="Ayarlar" />} />
        <Route path="yardim-destek" element={<ComingSoon pagesName="Yardım & Destek" />} />
      </Route>

    </Routes>
  );
}

export default App;
